import { QuestionnaireItemProps } from "./index";
import PregnancyDataTable from "./PregnancyDataTable";

export default function TabulatedData(props: QuestionnaireItemProps) {
  // Returns only pregnancy history table for now
  return <PregnancyDataTable {...props} />;
}
